<div class="document-preview">
  <div class="preview-header">
    <h4 class="preview-label">{{ label }}</h4>
    <span class="file-size">{{ formatFileSize(fileInfo.size) }}</span>
  </div>

  <div class="preview-container">
    <!-- Image Preview -->
    <div *ngIf="isImage && fileInfo.preview" class="image-preview">
      <img 
        [src]="fileInfo.preview" 
        [alt]="fileInfo.name"
        [style.transform]="transformStyle"
        class="preview-image"
      />
    </div>

    <!-- PDF Preview -->
    <div *ngIf="isPdf" class="pdf-preview">
      <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
      <span class="pdf-name">{{ fileInfo.name }}</span>
    </div>
  </div>

  <!-- Preview Controls -->
  <div class="preview-controls" *ngIf="isImage && (canRotate || canZoom)">
    <button 
      *ngIf="canRotate" 
      mat-icon-button 
      (click)="rotateImage()"
      matTooltip="Rotate"
      class="control-btn"
    >
      <mat-icon>rotate_right</mat-icon>
    </button>
    
    <button 
      *ngIf="canZoom" 
      mat-icon-button 
      (click)="zoomOut()"
      matTooltip="Zoom Out"
      class="control-btn"
      [disabled]="zoom <= 0.5"
    >
      <mat-icon>zoom_out</mat-icon>
    </button>
    
    <span *ngIf="canZoom" class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
    
    <button 
      *ngIf="canZoom" 
      mat-icon-button 
      (click)="zoomIn()"
      matTooltip="Zoom In"
      class="control-btn"
      [disabled]="zoom >= 3"
    >
      <mat-icon>zoom_in</mat-icon>
    </button>
    
    <button 
      *ngIf="canZoom || canRotate" 
      mat-icon-button 
      (click)="resetZoom()"
      matTooltip="Reset"
      class="control-btn"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <!-- Action Buttons -->
  <div class="preview-actions">
    <button 
      mat-stroked-button 
      color="primary"
      (click)="onReplace()"
      class="action-btn"
    >
      <mat-icon>swap_horiz</mat-icon>
      Replace
    </button>
    
    <button 
      *ngIf="canRemove"
      mat-stroked-button 
      color="warn"
      (click)="onRemove()"
      class="action-btn"
    >
      <mat-icon>delete</mat-icon>
      Remove
    </button>
  </div>
</div>
